"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATH_SEPARATOR = '$|$';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sidenav/constants.js
// module id = ./node_modules/react-sidenav/constants.js
// module chunks = 0